<template>
  <div class="mine-page">
    <div class="user-header">
      <img :src="userInfo.headimgurl || defaultAvatar" class="avatar" />
      <div class="user-info">
        <div class="nickname">{{ userInfo.realName ||userInfo.nickname  || '用户' }}</div>
        <div class="phone" v-if="userInfo.phone">{{ userInfo.phone }}</div>
      </div>
    </div>

    <van-cell-group class="menu-group">
      <van-cell title="我的预约" icon="notes-o" is-link @click="goMyAppointment" />
    </van-cell-group>

    <van-tabbar v-model="active" @change="onChange">
      <van-tabbar-item icon="home-o" to="/index/index">首页</van-tabbar-item>
      <van-tabbar-item icon="calendar-o" to="/yuyue/index">预约</van-tabbar-item>
      <van-tabbar-item icon="user-o" to="/mine/index">我的</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: 'Mine',
  data() {
    return {
      active: 2,
      defaultAvatar: '',
      userInfo: {}
    }
  },
  created() {
    this.loadUserInfo();
  },
  methods: {
    loadUserInfo() {
      var user = this.$tool.getUser();
      if (user) {
        this.userInfo = user;
      }
    },
    onChange(index) {
      console.log('切换到索引：', index);
    },
    goMyAppointment() {
      this.$router.push('/mine/myAppointment');
    }
  }
}
</script>

<style scoped>
.mine-page {
  background: #f5f5f5;
  min-height: 100vh;
}
.van-tabbar-item--active {
  color: #3e97c1;
}
.user-header {
  background: linear-gradient(135deg, #3e97c1, #2d7eb0);
  padding: 30px 20px;
  display: flex;
  align-items: center;
  color: #fff;
}
.avatar {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  border: 3px solid rgba(255, 255, 255, 0.5);
  margin-right: 16px;
}
.user-info {
  flex: 1;
}
.nickname {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 8px;
}
.phone {
  font-size: 14px;
  opacity: 0.9;
}
.menu-group {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/mine/index.vue